import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';
import * as firebase from 'firebase/app';

interface ApprovedAssistance {
    active: boolean;
    approbationDate: any;
    assistanceReportId: string;
    captureUser: string;
    createdAt: any;
    employeeId: string;
    type: number; // 1-CheckClock 2-Supervisor 3-Transportista 4-Apuntador
    updatedAt: any;
}

interface ApprovedAssistanceId extends ApprovedAssistance {
    id: string;
}

@Injectable()
export class ApprovedAssistanceService {

    approvedAssistanceCollection: AngularFirestoreCollection<ApprovedAssistance>;
    approvedAssistanceReports: any;

    approvedAssistanceDocument: AngularFirestoreDocument<ApprovedAssistanceId>;
    approvedAssistance: Observable<any>;

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.APPROVED_ASSISTANCE_COLLECTION;
    }

    postApprovedAssistance(approvedAssistanceObject: any) {
        this.approvedAssistanceCollection = this.afs.collection(this.collection);

        return this.approvedAssistanceCollection.add(approvedAssistanceObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
            return docRef.id;
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getApprovedAssistancesByReportDate(iAssistanceReportId: string) {
        this.approvedAssistanceCollection = this.afs.collection(this.collection,
                                            ref => ref.where('assistanceReportId', '==', iAssistanceReportId));

        this.approvedAssistanceReports = this.approvedAssistanceCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as ApprovedAssistance;

                const assistanceReportId = data.assistanceReportId;
                const employeeId = data.employeeId;
                const type = data.type;

                return { id$, assistanceReportId, employeeId, type };
            });
        }).map(object => object);

        return this.approvedAssistanceReports;
    }

}
